import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import { selectAllFormFields } from 'entities/creditForm';
import { isBentoRankingModelSelector } from 'entities/offers';
import { collectWLOtherDataSelector } from 'entities/whiteLabels';

import type { TAdditionalData } from 'features/OfferControls';

import { mplOfferToPreApprovalDataAdapter } from './mplOfferToPreApprovalDataAdapter';

type SendOfferThunkProps = {
  offer: MPLPreApprovalOffer;
  other?: Omit<TAdditionalData, 'pledgeAutoData' | 'pledgeEstateData'>;
};

export const collectMplPreApprovalDataThunk =
  ({ offer, other }: SendOfferThunkProps): ThunkResult<ReturnType<typeof mplOfferToPreApprovalDataAdapter>> =>
  (_, getState) => {
    const state = getState();
    const formData = selectAllFormFields(state);
    const isBentoRankingModel = isBentoRankingModelSelector(state);
    const otherWlData = collectWLOtherDataSelector(state);

    return mplOfferToPreApprovalDataAdapter(offer, formData, {
      ...(isBentoRankingModel ? { isBentoRankingModel } : {}),
      ...other,
      ...otherWlData,
    });
  };
